module.exports = "<div class=\"photo photo1 photo--large\">\n  Sup, dog\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/raw-loader!/Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/flexbox-patterns/src/examples/photo.html
// module id = 767
// module chunks = 0